import { render, staticRenderFns } from "./schoolViewAdd.vue?vue&type=template&id=cdbe9e02"
import script from "./schoolViewAdd.vue?vue&type=script&lang=js"
export * from "./schoolViewAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdbe9e02')) {
      api.createRecord('cdbe9e02', component.options)
    } else {
      api.reload('cdbe9e02', component.options)
    }
    module.hot.accept("./schoolViewAdd.vue?vue&type=template&id=cdbe9e02", function () {
      api.rerender('cdbe9e02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/school/schoolViewAdd.vue"
export default component.exports